import React, { useEffect, useState } from "react";
import { MdEmail, MdPhone } from "react-icons/md";
import contactImg from "../images/contact.jpg";
import emailjs from "emailjs-com";
import 'aos/dist/aos.css';
import AOS from 'aos';

const Contact = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out', 
      once: false, 
    });
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [statusMessage, setStatusMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_et54nhc", // Replace with your EmailJS service ID
        "template_s4uivsr", // Replace with your EmailJS template ID
        e.target,
        "XX_Iz7N2DtNYIpvRN" // Replace with your EmailJS user ID
      )
      .then(
        (result) => {
          setStatusMessage("Message sent successfully!");
          setFormData({
            name: "",
            email: "",
            message: "",
          });
          
          // Hide the success message after 3 seconds
          setTimeout(() => {
            setStatusMessage("");
          }, 3000);
        },
        (error) => {
          setStatusMessage("Something went wrong. Please try again later."); 
          setTimeout(() => {
            setStatusMessage("");
          }, 3000);
        }
      );
  };

  return (
    <div className="flex flex-col justify-center items-center mx-10 mb-16 pt-28 md:pt-16 gap-8">
      <div className="flex items-start" data-aos="fade-up">
        <p className="text-2xl tracking-widest font-extrabold">CONTACT ME</p>
      </div>

      <div className="flex flex-col md:flex-col lg:flex-row justify-center items-center md:justify-between gap-10">
        <div className="w-full md:w-2/4" data-aos="fade-up-right">
          <img src={contactImg} width={1000} className="h-full object-cover" />
        </div>

        <div className="w-full md:w-2/4" data-aos="fade-up-left">
          <form onSubmit={handleSubmit}>
            <div>
              <div className="mb-3">
                <input
                  className="w-full bg-transparent border border-gray-300 p-2"
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Name"
                  required
                />
              </div>
              <div className="mb-3">
                <input
                  className="w-full bg-transparent border border-gray-300 p-2"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email"
                  required
                />
              </div>
              <div className="mb-3">
                <textarea
                  className="w-full bg-transparent border border-gray-300 p-2"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="8"
                  placeholder="Message"
                  required
                ></textarea>
              </div>
            </div>
            <div className="text-start">
              <button type="submit" className="px-4 py-2 border border-gray-300 hover:border-[#00E6F6] hover:scale-110 transition-all duration-300 ease-in-out">
                Send Message
              </button>
            </div>
          </form>

          {/* Display status message below the button for 3 seconds */}
          {statusMessage && (
            <div className="mt-4 text-left text-lg text-white">
              {statusMessage}
            </div>
          )}
        </div>
      </div>


      <div className="text-center flex flex-col gap-2 mx-5" data-aos="fade-up">
        <p className="text-xl tracking-widest font-semibold">Get in touch</p>
        <hr />
        <div className="flex flex-row items-center gap-2 md:gap-5">
          <a
            href="mailto:skameshsurya@gmail.com"
            className="flex items-center decoration-none"
          >
            <MdEmail size={22} />{" "}
            <span className="ms-2">skameshsurya@gmail.com</span>
          </a>
          <a
            href="tel:+919003384088"
            className="flex items-center decoration-none"
          >
            <MdPhone size={22} />{" "}
            <span className="ms-2">9003384088</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Contact;
